<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Receitas Planos</h5>
    </div>

    <!-- Filtros -->
    <div class="mb-3">
      <div class="row g-2 align-items-end mb-2">
        <div class="col-12 col-md-6 col-lg-3">
          <select v-model="filters.plano" @change="filtrar" class="form-select form-select-sm">
            <option value="">Plano de Contas</option>
            <option value="Mensalidade">Mensalidade</option>
            <option value="Matrícula">Matrícula</option>
          </select>
        </div>
        <div class="col-12 col-md-6 col-lg-2">
          <select v-model="filters.pagamento" @change="filtrar" class="form-select form-select-sm">
            <option value="">Pagamento</option>
            <option value="hoje">Hoje</option>
            <option value="anteriores">Anteriores</option>
            <option value="futuros">Futuros</option>
            <option value="pendentes">Pendentes</option>
            <option value="canceladas">Cancelados</option>
          </select>
        </div>
        <div class="col-12 col-md-6 col-lg-2">
          <select v-model="filters.recebimento" @change="filtrar" class="form-select form-select-sm">
            <option value="">Recebimento</option>
            <option value="hoje">Hoje</option>
            <option value="anteriores">Anteriores</option>
            <option value="futuros">Futuros</option>
            <option value="pendentes">Pendentes</option>
            <option value="canceladas">Cancelados</option>
          </select>
        </div>
        <div class="col-12 col-md-6 col-lg-2">
          <input
            type="month"
            v-model="filters.mesAno"
            class="form-control"
            @change="filtrar"
            title="Filtrar por mês/ano do vencimento"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <select v-model="filters.forma" @change="filtrar" class="form-select form-select-sm">
            <option value="">Forma de Pagamento</option>
            <option v-for="f in formas" :key="f.id" :value="f.nome">{{ f.nome }}</option>
          </select>
        </div>
      </div>
      <div class="row g-2 align-items-end">
        <div class="col-12 col-md-6 col-lg-2">
          <input
            v-model="filters.autorizacao"
            placeholder="Autorização"
            class="form-control"
            @input="filtrar"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-1">
          <input
            v-model="filters.id"
            placeholder="ID"
            class="form-control"
            inputmode="numeric"
            @input="filtrar"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-1">
          <input
            v-model="filters.matricula"
            placeholder="Matrícula"
            class="form-control"
            inputmode="numeric"
            @input="filtrar"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <input v-model="filters.valor" placeholder="Filtrar por valor: 0,00" aria-label="Filtrar por valor" class="form-control" @input="filtrar" />
        </div>
        <div class="col-12 col-md-6 col-lg">
          <input
            v-model="filters.descricao"
            placeholder="Descrição"
            class="form-control"
            @input="filtrar"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-auto d-flex justify-content-end">
          <b-button
            variant="secondary"
            @click="limparFiltros"
            class="d-flex align-items-center justify-content-center"
          >
            <i class="bi bi-funnel mr-2" title="Limpar Filtros"></i>
          </b-button>
        </div>
      </div>
    </div>

    <!-- Tabela -->
    <div v-if="carregandoReceitas" role="status">Carregando receitas...</div>
    <div v-else-if="erroReceitas" role="alert" class="alert alert-danger">
      {{ erroReceitas }} <button class="btn btn-link" @click="carregarReceitas">Tentar novamente</button>
    </div>
    <div v-else-if="!receitas.length" role="status">Nenhum registro encontrado.</div>
    <table v-if="!carregandoReceitas && !erroReceitas && receitas.length" class="table table-striped table-hover">
      <thead>
        <tr>
          <th>
            <button class="btn btn-link p-0" @click="sort('id')">
              ID {{ arrow('id') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('matricula_id')">
              Matrícula {{ arrow('matricula_id') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('plano_contas')">
              Plano de Contas {{ arrow('plano_contas') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('valor')">
              Valor {{ arrow('valor') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('data_vencimento')">
              Vencimento {{ arrow('data_vencimento') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('data_pagamento')">
              Pagamento {{ arrow('data_pagamento') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('data_recebimento')">
              Recebimento {{ arrow('data_recebimento') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('forma_pagamento')">
              Forma de Pagamento {{ arrow('forma_pagamento') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('numero_autorizacao')">
              Autorização {{ arrow('numero_autorizacao') }}
            </button>
          </th>
          <th>Situação</th>
          <th>Descrição</th>
          <!-- <th>Observação</th> -->
          <th class="text-end">Ações</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="row in receitas" :key="String(row.id)">
          <td>{{ formatFriendlyId(row) }}</td>
          <td>{{ row.matricula_id }}</td>
          <td>
            <span v-if="row.plano_contas === 'Mensalidade'" class="text-success">
              {{ row.plano_contas }}
            </span>
            <span v-else class="text-primary">{{ row.plano_contas }}</span>
          </td>
          <td>{{ formatCurrency(row.valor) }}</td>
          <td>{{ formatDate(row.data_vencimento) }}</td>
          <td>
            <span v-if="chequeStatus(row) === 'SUBSTITUIDO'" class="text-muted">
              Cancelado
            </span>
            <span v-else-if="row.data_pagamento">
              {{ formatDate(row.data_pagamento) }}
            </span>
            <span v-else class="text-danger">
              Pendente
            </span>
          </td>
          <td>
            <span v-if="chequeStatus(row) === 'SUBSTITUIDO'" class="text-muted">
              Cancelado
            </span>
            <span v-else-if="row.data_recebimento">
              {{ formatDate(row.data_recebimento) }}
            </span>
            <span v-else class="text-danger">
              Pendente
            </span>
          </td>
          <td>{{ formaPagamentoLabel(row) }}</td>
          <td>{{ row.numero_autorizacao || '—' }}</td>
          <td>
            <span :class="chequeStatusClass(row)">
              {{ chequeStatusLabel(row) }}
            </span>
          </td>
          <td>{{ row.descricao }}</td>
          <!-- <td>{{ row.observacoes }}</td> -->
          <td class="text-end">
            <i
              v-if="hasPermission('detalhar_receitas_planos')"
              class="bi bi-eye-fill text-primary mx-1"
              role="button"
              @click="detalhar(row.id)"
            ></i>

            <i
              v-if="podeEditarReceita(row)"
              class="bi bi-pencil-fill text-warning mx-1"
              role="button"
              @click="editarReceita(row)"
            ></i>

            <i
              v-if="podeTratarCheque(row)"
              class="bi bi-arrow-counterclockwise text-danger mx-1"
              role="button"
              title="Marcar cheque como devolvido"
              @click="abrirModalCheque(row, 'devolvido')"
            ></i>

            <i
              v-if="podeCorrigirDevolucaoCheque(row)"
              class="bi bi-calendar-event text-info mx-1"
              role="button"
              title="Corrigir data da devolução"
              @click="abrirModalCheque(row, 'corrigir_devolucao')"
            ></i>

            <i
              v-if="podeReapresentarCheque(row)"
              class="bi bi-arrow-repeat text-primary mx-1"
              role="button"
              title="Marcar cheque como reapresentado"
              @click="abrirModalCheque(row, 'reapresentado')"
            ></i>

            <!-- <i
              v-if="podeCompensarCheque(row)"
              class="bi bi-check-circle-fill text-success mx-1"
              role="button"
              title="Marcar cheque como compensado"
              @click="abrirModalCheque(row, 'compensado')"
            ></i> -->

            <i
              v-if="podeSubstituirCheque(row)"
              class="bi bi-cash-coin text-secondary mx-1"
              role="button"
              title="Substituir cheque por outra forma"
              @click="abrirModalCheque(row, 'substituido')"
            ></i>

            <i
              v-if="hasPermission('excluir_receitas_planos')"
              class="bi bi-trash-fill text-danger mx-1"
              role="button"
              @click="excluir(row.id)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Paginação -->
    <div v-if="!carregandoReceitas && !erroReceitas && receitas.length" class="d-flex justify-content-between align-items mt-3">
      <div>Mostrando {{ startRow }} a {{ endRow }} de {{ totalRegistros }} registros</div>

      <div class="d-flex align-items" style="gap: .5rem;">
        <b-form-select
          v-model="limitePorPagina"
          :options="pageOptions.map(n => ({ value: n, text: n + ' / página' }))"
          size="sm"
          style="width: 6rem"
          @change="paginaAtual = 1; carregarReceitas()"
        />
      </div>

      <div class="d-flex align-items">
        <b-pagination
          v-model="paginaAtual"
          :per-page="limitePorPagina"
          :total-rows="totalRegistros"
          size="sm"
          limit="5"
          @input="carregarReceitas"
        />
      </div>
    </div>

    <!-- Modal de edição -->
    <EditarReceitasPlanos
      v-if="showEditModal && hasPermission('alterar_receitas_planos')"
      :key="editId"
      :id="editId"
      @updated="onEditSuccess"
      @cancel="showEditModal = false; editId = null"
    />

    <div v-if="showChequeModal" class="cheque-modal-overlay">
      <div class="cheque-modal-container">
        <div class="cheque-modal-header">
          <h6>{{ tituloModalCheque }}</h6>
          <i class="bi bi-x-circle close-icon" @click="fecharModalCheque"></i>
        </div>

        <div class="cheque-modal-content">
          <div class="alert alert-light border mb-3">
            <div><strong>ID:</strong> {{ formatFriendlyId(chequeRegistro) }}</div>
            <div><strong>Tipo:</strong> {{ chequeRegistro?.plano_contas }}</div>
            <div><strong>Aluno:</strong> {{ chequeRegistro?.descricao }}</div>
            <div><strong>Valor:</strong> {{ formatCurrency(chequeRegistro?.valor) }}</div>
            <div><strong>Cheque:</strong> {{ chequeRegistro?.cheque_numero || '—' }}</div>
            <div><strong>Situação atual:</strong> {{ chequeStatusLabel(chequeRegistro) }}</div>
          </div>

          <div
            v-if="chequeAcao === 'corrigir_devolucao'"
            class="alert alert-info py-2 mb-3"
          >
            Ajuste apenas a data da devolução já registrada. Essa ação não reabre o pagamento novamente e não altera a reapresentação/substituição.
          </div>

          <div class="row">
            <div
              class="col-md-4"
              v-if="chequeAcao === 'devolvido' || chequeAcao === 'corrigir_devolucao'"
            >
              <label>Data da devolução *</label>
              <input type="date" v-model="chequeForm.data_devolucao" class="form-control" />
            </div>

            <div class="col-md-4" v-if="chequeAcao === 'reapresentado'">
              <label>Data da reapresentação *</label>
              <input type="date" v-model="chequeForm.data_reapresentacao" class="form-control" />
            </div>

            <div class="col-md-4" v-if="chequeAcao === 'compensado'">
              <label>Data da compensação *</label>
              <input type="date" v-model="chequeForm.data_compensacao" class="form-control" />
            </div>

            <div class="col-md-4" v-if="chequeAcao === 'substituido'">
              <label>Data da substituição *</label>
              <input type="date" v-model="chequeForm.data_substituicao" class="form-control" />
            </div>

            <div
              class="col-md-8"
              v-if="chequeAcao === 'devolvido' || chequeAcao === 'corrigir_devolucao'"
            >
              <label>Motivo da devolução</label>
              <input
                type="text"
                v-model="chequeForm.motivo_devolucao"
                class="form-control"
                placeholder="Ex.: Sem fundos, sustado, divergência..."
              />
            </div>
          </div>

          <div v-if="chequeAcao === 'substituido'" class="row mt-3">
            <div class="col-md-4">
              <label>Nova forma de pagamento *</label>
              <select
                v-model.number="chequeForm.forma_pagamento_id"
                class="form-control"
                @change="recalcularRecebimentoCheque"
              >
                <option :value="null">Selecione</option>
                <option
                  v-for="f in formasSemCheque"
                  :key="f.id"
                  :value="f.id"
                >
                  {{ f.nome }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <label>Data de pagamento *</label>
              <input
                type="date"
                v-model="chequeForm.data_pagamento"
                class="form-control"
                @change="recalcularRecebimentoCheque"
              />
            </div>

            <div class="col-md-4">
              <label>Data de recebimento *</label>
              <input type="date" v-model="chequeForm.data_recebimento" class="form-control" />
            </div>

            <div class="col-md-4 mt-3">
              <label>Conta financeira *</label>
              <select v-model.number="chequeForm.conta_financeira_id" class="form-control">
                <option :value="null">Selecione</option>
                <option
                  v-for="c in contasFinanceiras"
                  :key="c.id"
                  :value="c.id"
                >
                  {{ c.texto }}
                </option>
              </select>
            </div>

            <div class="col-md-4 mt-3">
              <label>Valor *</label>
              <input
                type="text"
                v-model="chequeForm.valor"
                class="form-control"
                placeholder="R$ 0,00"
                @focus="prepararEdicaoMoeda"
                @blur="formatarValorCheque"
              />
            </div>

            <div class="col-md-4 mt-3" v-if="substituicaoExigeAutorizacao">
              <label>Autorização *</label>
              <input
                type="text"
                v-model="chequeForm.numero_autorizacao"
                class="form-control"
                placeholder="Informe a autorização"
              />
            </div>
          </div>

          <div class="mt-3">
            <label>Observação</label>
            <textarea
              v-model="chequeForm.observacao"
              class="form-control"
              rows="3"
            ></textarea>
          </div>

          <div class="d-flex justify-content-end mt-4" style="gap: 10px;">
            <button class="btn btn-secondary" @click="fecharModalCheque">
              Cancelar
            </button>

            <button class="btn btn-primary" :disabled="salvandoCheque" @click="confirmarAcaoCheque">
              {{ salvandoCheque ? 'Salvando...' : 'Confirmar' }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from '@/services/axios';
import { useReceitasPermissions } from '@/composables/useReceitasPermissions';
import { BButton, BPagination, BFormSelect } from 'bootstrap-vue-next';
import EditarReceitasPlanos from '@/components/modals/EditarReceitasPlanos.vue';
import globalUtils from '@/utils/globalUtils';

export default {
  name: 'ListarReceitasPlanos',
  setup: useReceitasPermissions,
  components: { BButton, BPagination, BFormSelect, EditarReceitasPlanos },

  data() {
    return {

      carregandoReceitas: true,
      erroReceitas: '',
      consultaReceitas: 0,
      receitas: [],
      showEditModal: false,
      editId: null,

      showChequeModal: false,
      chequeRegistro: null,
      chequeAcao: null,
      salvandoCheque: false,
      contasFinanceiras: [],

      chequeForm: {
        data_devolucao: '',
        motivo_devolucao: '',
        data_reapresentacao: '',
        data_compensacao: '',
        data_substituicao: '',
        forma_pagamento_id: null,
        data_pagamento: '',
        data_recebimento: '',
        conta_financeira_id: null,
        valor: null,
        numero_autorizacao: '',
        observacao: '',
      },

      formas: [],

      fields: [
        { key: 'seq', label: '#', sortable: false },
        { key: 'plano_contas', label: 'Plano de Contas', sortable: true },
        { key: 'valor', label: 'Valor', sortable: true },
        { key: 'data_vencimento', label: 'Vencimento', sortable: true },
        { key: 'data_pagamento', label: 'Pagamento', sortable: true },
        { key: 'data_recebimento', label: 'Recebimento', sortable: true },
        { key: 'forma_pagamento', label: 'Forma de Pagamento', sortable: true },
        { key: 'descricao', label: 'Descrição', sortable: false },
        { key: 'observacoes', label: 'Observação', sortable: false },
        { key: 'actions', label: 'Ações', class: 'text-end' },
      ],

      filters: {
        valor: '',
        id: '',
        matricula: '',
        pagamento: '',
        recebimento: '',
        plano: '',
        forma: '',
        autorizacao: '',
        descricao: '',
        observacoes: '',
        mesAno: '',
      },

      paginaAtual: 1,
      limitePorPagina: 10,
      totalPaginas: 1,
      totalRegistros: 0,
      pageOptions: [10, 15, 20, 25, 50],

      currentSort: { key: 'data_pagamento', order: 'desc' },
    };
  },

  computed: {
    startRow() {
      return (this.paginaAtual - 1) * this.limitePorPagina + 1;
    },

    endRow() {
      return Math.min(this.paginaAtual * this.limitePorPagina, this.totalRegistros);
    },

    tituloModalCheque() {
      const labels = {
        devolvido: 'Marcar cheque como devolvido',
        corrigir_devolucao: 'Corrigir data da devolução do cheque',
        reapresentado: 'Marcar cheque como reapresentado',
        compensado: 'Marcar cheque como compensado',
        substituido: 'Substituir cheque por outra forma de pagamento',
      };

      return labels[this.chequeAcao] || 'Ação de cheque';
    },

    formasSemCheque() {
      return (this.formas || []).filter(f => !this.isChequeNome(f.nome));
    },

    formaPagamentoSubstituicaoSelecionada() {
      const formaId = this.chequeForm?.forma_pagamento_id;

      if (!formaId) return null;

      return (this.formas || []).find(f => Number(f.id) === Number(formaId)) || null;
    },

    substituicaoExigeAutorizacao() {
      const nome = String(this.formaPagamentoSubstituicaoSelecionada?.nome || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();

      return nome.includes('cartao') || nome.includes('credito') || nome.includes('debito');
    },
  },

  watch: {
    paginaAtual() {
      this.carregarReceitas();
    },
  },

  methods: {
    sort(col) {
      if (this.currentSort.key === col) {
        this.currentSort.order = this.currentSort.order === 'asc' ? 'desc' : 'asc';
      } else {
        this.currentSort.key = col;
        this.currentSort.order = 'asc';
      }

      this.carregarReceitas();
    },

    arrow(col) {
      return this.currentSort.key !== col ? '' : (this.currentSort.order === 'asc' ? '▲' : '▼');
    },

    podeEditarReceita(row) {
      return this.hasPermission('alterar_receitas_planos') && !!row
        && !row.substituida
        && (!row.cheque_status || row.cheque_status === 'NORMAL');
    },

    async editarReceita(row) {
      if (!await this.authorizeReceiptAction('alterar_receitas_planos')) return;
      if (!this.podeEditarReceita(row)) return;
      this.editId = row?.id;
      this.showEditModal = true;
    },

    onEditSuccess() {
      this.showEditModal = false;
      this.editId = null;
      this.carregarReceitas();
    },

    async carregarFormas() {
      try {
        const res = await axios.get('/cadastros/formas-pagamento');
        this.formas = res.data;
      } catch (e) {
        console.error('Erro ao carregar formas:', e);
      }
    },

    async carregarReceitas() {
      const request = ++this.consultaReceitas;
      this.carregandoReceitas = true;
      this.erroReceitas = '';
      this.receitas = [];
      try {
        await this.fetchPermissions();
        if (request !== this.consultaReceitas) return;
        if (this.permissionsError) throw new Error(this.permissionsError);
        if (!this.hasPermission('listar_receitas_planos')) throw new Error('Você não possui permissão para consultar estas receitas.');
        const res = await axios.get('/financeiro/receitas-planos', {
          params: {
            page: this.paginaAtual,
            limit: this.limitePorPagina,
            sortBy: this.currentSort.key,
            order: this.currentSort.order,

            id: this.filters.id || undefined,
            matricula: this.filters.matricula || undefined,
            pagamento: this.filters.pagamento || undefined,
            recebimento: this.filters.recebimento || undefined,
            plano: this.filters.plano || undefined,
            forma: this.filters.forma || undefined,
            autorizacao: this.filters.autorizacao || undefined,
            valor: this.filters.valor || undefined,
            descricao: this.filters.descricao || undefined,
            observacoes: this.filters.observacoes || undefined,
            mesAno: this.filters.mesAno || undefined,
          },
        });

        if (request !== this.consultaReceitas) return;
        if (!Array.isArray(res.data?.data)) throw new Error('Resposta inválida da listagem. Tente novamente.');
        const { data, totalPages, totalItems } = res.data;

        this.receitas = (data || []).map((item, i) => ({
          ...item,
          seq: i + 1 + (this.paginaAtual - 1) * this.limitePorPagina,
        }));

        this.totalPaginas = totalPages || 1;
        this.totalRegistros = totalItems || 0;
      } catch (error) {
        if (request !== this.consultaReceitas) return;
        this.erroReceitas = [401, 403].includes(error.response?.status)
          ? 'Sessão expirada ou acesso negado. Entre novamente ou verifique sua permissão de consulta.'
          : error.response ? 'Não foi possível carregar as receitas. Tente novamente.'
          : error.message || 'Não foi possível carregar as receitas. Tente novamente.';
      } finally {
        if (request === this.consultaReceitas) this.carregandoReceitas = false;
      }
    },

    formatDate(dt) {
      return globalUtils.formatarData(dt) || '—';
    },

    formatCurrency(val) {
      return val != null
        ? Number(val).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        : '—';
    },

    async filtrar() {
      this.paginaAtual = 1;
      this.carregarReceitas();
    },

    limparFiltros() {
      this.filters = {
        valor: '',
        id: '',
        matricula: '',
        pagamento: '',
        recebimento: '',
        plano: '',
        forma: '',
        autorizacao: '',
        descricao: '',
        observacoes: '',
        mesAno: '',
      };

      this.paginaAtual = 1;
      this.carregarReceitas();
    },

    formatFriendlyId(row) {
      if (!row) return '—';

      const origemId = row.origem_id ?? row.id;
      const origem = String(row.origem || '').toUpperCase();

      if (origem === 'MP') return `${origemId}`;
      if (origem === 'PM') return `${origemId}`;

      return String(origemId ?? '—');
    },

    async detalhar(id) {
      if (!await this.authorizeReceiptAction('detalhar_receitas_planos')) return;
      this.$router.push(`/financeiro/receitas-planos/${id}/detalhar`);
    },

    async excluir(id) {
      if (!await this.authorizeReceiptAction('excluir_receitas_planos')) return;
      const confirmou = await this.$confirm('Confirma excluir esta receita?', 'Confirmação');
      if (!confirmou) return;

      try {
        if (!await this.authorizeReceiptAction('excluir_receitas_planos')) return;
        await axios.delete(`/financeiro/receitas-planos/${id}`);
        this.carregarReceitas();
        this.$toast?.success?.('Receita excluída');
      } catch (e) {
        console.error('Erro ao excluir receita:', e);
        this.$toast?.error?.('Erro ao excluir receita');
      }
    },

    isChequeNome(nome) {
      return String(nome || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .includes('cheque');
    },

    isChequeRow(row) {
      return this.isChequeNome(row?.forma_pagamento);
    },

    formaPagamentoLabel(row) {
      const numero = String(row?.cheque_numero ?? '').trim();
      return this.isChequeRow(row) && numero
        ? `${row.forma_pagamento} (${numero})`
        : row.forma_pagamento;
    },

    chequeStatus(row) {
      return String(row?.cheque_status || 'NORMAL').toUpperCase();
    },

    chequeStatusLabel(row) {
      const status = this.chequeStatus(row);

      if (status === 'DEVOLVIDO') return 'Cheque devolvido';
      if (status === 'REAPRESENTADO') return 'Cheque reapresentado';
      if (status === 'COMPENSADO') return 'Cheque compensado';
      if (status === 'SUBSTITUIDO') return 'Substituído';

      if (row?.data_pagamento) return 'Pago';
      return 'Pendente';
    },

    chequeStatusClass(row) {
      const status = this.chequeStatus(row);

      if (status === 'DEVOLVIDO') return 'badge bg-danger';
      if (status === 'REAPRESENTADO') return 'badge bg-primary';
      if (status === 'COMPENSADO') return 'badge bg-success';
      if (status === 'SUBSTITUIDO') return 'badge bg-secondary';

      if (row?.data_pagamento) return 'badge bg-success';
      return 'badge bg-warning text-dark';
    },

    podeTratarCheque(row) {
      if (!this.hasPermission('alterar_receitas_planos') || !this.hasPermission('alterar_matriculas')) return false;
      const status = this.chequeStatus(row);
      return this.isChequeRow(row) && ['NORMAL', 'COMPENSADO', 'REAPRESENTADO'].includes(status);
    },

    podeCorrigirDevolucaoCheque(row) {
      if (!this.hasPermission('alterar_receitas_planos') || !this.hasPermission('alterar_matriculas')) return false;
      return this.isChequeRow(row) && this.chequeStatus(row) === 'DEVOLVIDO';
    },

    podeReapresentarCheque(row) {
      if (!this.hasPermission('alterar_receitas_planos') || !this.hasPermission('alterar_matriculas')) return false;
      return this.isChequeRow(row) && this.chequeStatus(row) === 'DEVOLVIDO';
    },

    podeCompensarCheque(row) {
      if (!this.hasPermission('alterar_receitas_planos') || !this.hasPermission('alterar_matriculas')) return false;
      const status = this.chequeStatus(row);
      return this.isChequeRow(row) && ['NORMAL', 'REAPRESENTADO'].includes(status);
    },

    podeSubstituirCheque(row) {
      if (!this.hasPermission('alterar_receitas_planos') || !this.hasPermission('alterar_matriculas')) return false;
      const status = this.chequeStatus(row);
      return this.isChequeRow(row) && ['DEVOLVIDO', 'REAPRESENTADO'].includes(status);
    },

    hojeISO() {
      const d = new Date();
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');

      return `${yyyy}-${mm}-${dd}`;
    },

    toISODate(dt) {
      if (!dt) return '';

      const s = String(dt).trim();

      if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
        return s.slice(0, 10);
      }

      const d = new Date(s);
      if (Number.isNaN(d.getTime())) return '';

      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');

      return `${yyyy}-${mm}-${dd}`;
    },

    recalcularRecebimentoCheque() {
      if (this.chequeAcao !== 'substituido') return;

      const dataPagamento = this.chequeForm.data_pagamento;
      const formaId = this.chequeForm.forma_pagamento_id;

      if (!this.substituicaoExigeAutorizacao) {
        this.chequeForm.numero_autorizacao = '';
      }

      if (!dataPagamento || !formaId) {
        this.chequeForm.data_recebimento = dataPagamento || '';
        return;
      }

      const forma = (this.formas || []).find(f => Number(f.id) === Number(formaId));

      this.chequeForm.data_recebimento = globalUtils.calcularDataRecebimento(
        dataPagamento,
        forma || formaId,
        this.formas || []
      );
    },

    async abrirModalCheque(row, acao) {
      if (!await this.authorizeReceiptAction('alterar_receitas_planos')) return;
      const hoje = this.hojeISO();

      this.chequeRegistro = row;
      this.chequeAcao = acao;

      this.chequeForm = {
        data_devolucao:
          acao === 'devolvido'
            ? hoje
            : acao === 'corrigir_devolucao'
              ? this.toISODate(row?.cheque_data_devolucao) || hoje
              : '',

        motivo_devolucao:
          acao === 'corrigir_devolucao'
            ? row?.cheque_motivo_devolucao || ''
            : '',

        data_reapresentacao: acao === 'reapresentado' ? hoje : '',
        data_compensacao: acao === 'compensado' ? hoje : '',
        data_substituicao: acao === 'substituido' ? hoje : '',
        forma_pagamento_id: null,
        data_pagamento: acao === 'substituido' ? hoje : '',
        data_recebimento: acao === 'substituido' ? hoje : '',
        conta_financeira_id: row?.conta_financeira_id || null,
        valor: row?.valor != null ? this.formatCurrency(row.valor) : '',
        numero_autorizacao: '',
        observacao: '',
      };

      if (acao === 'substituido') {
        this.recalcularRecebimentoCheque();
      }

      this.showChequeModal = true;
    },

    fecharModalCheque() {
      this.showChequeModal = false;
      this.chequeRegistro = null;
      this.chequeAcao = null;
      this.salvandoCheque = false;
    },

    validarChequeForm() {
      if (
        ['devolvido', 'corrigir_devolucao'].includes(this.chequeAcao) &&
        !this.chequeForm.data_devolucao
      ) {
        return 'Informe a data da devolução.';
      }

      if (this.chequeAcao === 'reapresentado' && !this.chequeForm.data_reapresentacao) {
        return 'Informe a data da reapresentação.';
      }

      if (this.chequeAcao === 'compensado' && !this.chequeForm.data_compensacao) {
        return 'Informe a data da compensação.';
      }

      if (this.chequeAcao === 'substituido') {
        if (!this.chequeForm.data_substituicao) return 'Informe a data da substituição.';
        if (!this.chequeForm.forma_pagamento_id) return 'Informe a nova forma de pagamento.';
        if (!this.chequeForm.data_pagamento) return 'Informe a data de pagamento.';
        if (!this.chequeForm.data_recebimento) return 'Informe a data de recebimento.';
        if (!this.chequeForm.conta_financeira_id) return 'Informe a conta financeira.';

        const valorNumerico = this.parseMoedaBR(this.chequeForm.valor);
        if (!valorNumerico || valorNumerico <= 0) return 'Informe um valor válido.';

        if (
          this.substituicaoExigeAutorizacao &&
          !String(this.chequeForm.numero_autorizacao || '').trim()
        ) {
          return 'Informe a autorização do cartão.';
        }
      }

      return null;
    },

    payloadCheque() {
      if (this.chequeAcao === 'devolvido' || this.chequeAcao === 'corrigir_devolucao') {
        return {
          data_devolucao: this.chequeForm.data_devolucao,
          motivo_devolucao: this.chequeForm.motivo_devolucao,
          observacao: this.chequeForm.observacao,
        };
      }

      if (this.chequeAcao === 'reapresentado') {
        return {
          data_reapresentacao: this.chequeForm.data_reapresentacao,
          observacao: this.chequeForm.observacao,
        };
      }

      if (this.chequeAcao === 'compensado') {
        return {
          data_compensacao: this.chequeForm.data_compensacao,
          observacao: this.chequeForm.observacao,
        };
      }

      return {
        data_substituicao: this.chequeForm.data_substituicao,
        forma_pagamento_id: this.chequeForm.forma_pagamento_id,
        data_pagamento: this.chequeForm.data_pagamento,
        data_recebimento: this.chequeForm.data_recebimento,
        conta_financeira_id: this.chequeForm.conta_financeira_id,
        valor: this.parseMoedaBR(this.chequeForm.valor),
        numero_autorizacao: this.substituicaoExigeAutorizacao
          ? String(this.chequeForm.numero_autorizacao || '').trim()
          : null,
        observacao: this.chequeForm.observacao,
      };
    },

    parseMoedaBR(valor) {
      if (valor == null || valor === '') return 0;

      if (typeof valor === 'number') return valor;

      const limpo = String(valor)
        .replace(/\s/g, '')
        .replace('R$', '')
        .replace(/\./g, '')
        .replace(',', '.');

      const numero = Number(limpo);

      return Number.isFinite(numero) ? numero : 0;
    },

    formatarValorCheque() {
      const valorNumerico = this.parseMoedaBR(this.chequeForm.valor);

      this.chequeForm.valor = valorNumerico
        ? valorNumerico.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          })
        : '';
    },

    prepararEdicaoMoeda() {
      const valorNumerico = this.parseMoedaBR(this.chequeForm.valor);

      this.chequeForm.valor = valorNumerico
        ? String(valorNumerico).replace('.', ',')
        : '';
    },

    async confirmarAcaoCheque() {
      if (!await this.authorizeReceiptAction('alterar_receitas_planos')) return;
      const erro = this.validarChequeForm();

      if (erro) {
        await this.$alert?.(erro, 'Atenção');
        return;
      }

      const labels = {
        devolvido: 'devolver este cheque',
        corrigir_devolucao: 'corrigir a data da devolução deste cheque',
        reapresentado: 'marcar este cheque como reapresentado',
        compensado: 'marcar este cheque como compensado',
        substituido: 'substituir este cheque por outra forma de pagamento',
      };

      const ok = await this.$confirm?.(
        `Confirma ${labels[this.chequeAcao] || 'realizar esta ação'}?`,
        'Confirmação'
      );

      if (!ok) return;

      this.salvandoCheque = true;

      try {
        const endpointAcao = this.chequeAcao === 'corrigir_devolucao'
          ? 'corrigir-devolucao'
          : this.chequeAcao;

        await axios.put(
          `/financeiro/receitas-planos/${this.chequeRegistro.id}/cheque-${endpointAcao}`,
          this.payloadCheque()
        );

        this.$toast?.success?.('Ação registrada com sucesso.');
        this.fecharModalCheque();
        await this.carregarReceitas();
      } catch (e) {
        console.error('Erro ao registrar ação do cheque:', e);
        const msg = e.response?.data?.error || 'Erro ao registrar ação do cheque.';
        await this.$alert?.(msg, 'Erro');
      } finally {
        this.salvandoCheque = false;
      }
    },

    async carregarContasFinanceiras() {
      if (!this.hasPermission('listar_contas_financeiras')) return;
      try {
        const res = await axios.get('/financeiro/contas-financeiras');
        const lista = res.data?.data || res.data || [];

        this.contasFinanceiras = lista.map(c => ({
          ...c,
          texto: c.apelido
            ? `${c.apelido} - ${c.instituicao || ''}`
            : `${c.instituicao || ''} - ${c.numero_conta || ''}`,
        }));
      } catch (e) {
        console.error('Erro ao carregar contas financeiras:', e);
      }
    },
  },

  async mounted() {
    await this.fetchPermissions();
    await this.carregarFormas();
    await this.carregarContasFinanceiras();
    this.carregarReceitas();
  },
};
</script>

<style scoped>
.table thead th button.btn-link {
  color: inherit;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  text-decoration: none;
  font: inherit;
  cursor: pointer;
}

.table thead th button.btn-link:hover {
  text-decoration: underline;
}

.cheque-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.cheque-modal-container {
  background: #fff;
  width: min(900px, 96vw);
  max-height: 92vh;
  overflow-y: auto;
  border-radius: 10px;
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.25);
}

.cheque-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 18px;
  border-bottom: 1px solid #e5e5e5;
}

.cheque-modal-content {
  padding: 18px;
}

.close-icon {
  cursor: pointer;
  font-size: 1.2rem;
}

:deep(.pagination.pagination-sm .page-link) {
  padding: 0.25rem 0.5rem;
  line-height: 1;
  font-size: 0.8rem !important;
  border-radius: 0 !important;
}
</style>